<template>
  <div class="area">
    <div v-if="!loading && data.length" id="chartdiv" ref="chartdiv" />
  </div>
</template>

<script lang="ts">
import {
  ref,
  shallowRef,
  onMounted,
  onBeforeUnmount,
  defineComponent
} from 'vue'

import { am4core, am4maps } from '@/utils/async_chart_loader'
import am4geodataWorldLow from '@amcharts/amcharts4-geodata/worldLow'

export default defineComponent({
  name: 'MapChart',
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  setup(props, context) {
    const chartdiv = ref(null)
    const chartBox = shallowRef()

    const renderChart = () => {
      clearChart()
      // @ts-ignore: Object is possibly 'null'.
      const chart = am4core.create(chartdiv.value, am4maps.MapChart)
      // Set map definition
      chart.geodata = am4geodataWorldLow

      // Set projection
      chart.projection = new am4maps.projections.Miller()
      // Create map polygon series
      const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())
      // Make map load polygon (like country names) data from GeoJSON
      polygonSeries.useGeodata = true
      // Configure series
      const polygonTemplate = polygonSeries.mapPolygons.template
      polygonTemplate.tooltipText = '{name}: {value}'
      polygonTemplate.fill = am4core.color('#999')

      // Add heat rule
      polygonSeries.heatRules.push({
        property: 'fill',
        target: polygonSeries.mapPolygons.template,
        min: chart.colors.getIndex(1).brighten(1),
        max: chart.colors.getIndex(1).brighten(-0.3),
        logarithmic: true
      })

      // Create hover state and set alternative fill color
      const hs = polygonTemplate.states.create('hover')
      hs.properties.fill = am4core.color('#367B25')
      // Remove Antarctica
      polygonSeries.exclude = ['AQ']

      polygonSeries.data = props.data

      const legend = new am4maps.Legend()
      const colorSet = new am4core.ColorSet()
      legend.parent = chart.chartContainer
      legend.position = 'top'
      legend.background.fill = am4core.color('#000')
      legend.background.fillOpacity = 0.05
      legend.width = 220
      legend.maxHeight = 300
      legend.scrollable = true
      legend.align = 'right'
      legend.padding(10, 15, 10, 15)
      legend.data = polygonSeries.data.slice(0, 10).map((c: any) => ({
        name: `${c.title}: ${c.value}`,
        fill: colorSet.next()
      }))
      legend.itemContainers.template.clickable = false
      legend.itemContainers.template.focusable = false

      var legendTitle = legend.createChild(am4core.Label)

      chartBox.value = chart
    }

    const clearChart = () => {
      if (chartBox.value && !chartBox.value.isDisposed) {
        chartBox.value.dispose()
        chartBox.value = null
      }
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      clearChart()
    })

    return { chartdiv }
  }
})
</script>

<style lang="scss" scoped>
.area {
  height: 400px !important;
  position: relative;
  .main-chart {
    background: #fff;
    height: 100%;
  }
  .el-radio-group {
    margin: 10px 0;
  }
  .center {
    position: absolute;
    margin: 0;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
#chartdiv {
  width: 100%;
  height: 100%;
}
</style>
